import { render } from "./leaves.vue?vue&type=template&id=10c2be9c"
import script from "./leaves.vue?vue&type=script&lang=js"
export * from "./leaves.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__